import {takeEvery} from 'redux-saga/effects'
import {
  ADD_SUBJECT_RESOURCES,
  ASSIGN_SUBJECT_TEACHERS,
  COPY_SUBSECTION,
  CREATE_SUBJECT,
  CREATE_SUBSECTIONS,
  DELETE_MANY_SUBSECTION,
  DELETE_SUBJECT_RESOURCES,
  DELETE_SUBSECTION,
  GENERATE_OVERALL_SUBJECT_REPORT,
  GENERATE_STUDENT_LIST,
  GET_EXCLUDE_SUBSECTIONS,
  GET_OBSERVEE_TEACHERS_SUBJECTS,
  GET_PREVIOUS_SUBJECTS,
  GET_STUDENTS_SUBJECTS_NEW,
  GET_SUBJECT,
  GET_SUBJECTS,
  GET_SUBJECTS_STUDENTS,
  GET_SUBJECT_EXAMS,
  GET_SUBJECT_RESOURCES,
  GET_SUBJECT_SEQUENCE,
  GET_SUBSECTION,
  GET_SUBSECTIONS,
  GET_SYLLABUS_SUBJECTS,
  LOAD_SUBJECT_LABELS,
  LOCK_SELECTED_OUTLINE,
  SET_SUBJECT_WEIGHTAGE,
  STUDENT_SUBJECT_REPORT,
  UNLOCK_SELECTED_OUTLINE,
  UPDATE_EXCLUDE_SUBSECTION,
  UPDATE_SUBJECTS,
  UPDATE_SUBJECT_SEQUENCE,
  UPDATE_SUBSECTION,
} from 'setup/redux/Actions/Subject/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_SUBJECTS, fetchData)
  yield takeEvery(GET_SUBJECT, fetchData)
  yield takeEvery(GET_SUBJECTS_STUDENTS, fetchData)
  yield takeEvery(CREATE_SUBJECT, fetchData)
  yield takeEvery(UPDATE_SUBJECTS, fetchData)
  yield takeEvery(UPDATE_SUBJECT_SEQUENCE, fetchData)
  yield takeEvery(GET_SUBJECT_SEQUENCE, fetchData)
  yield takeEvery(GENERATE_STUDENT_LIST, fetchData)
  yield takeEvery(GENERATE_OVERALL_SUBJECT_REPORT, fetchData)
  yield takeEvery(SET_SUBJECT_WEIGHTAGE, fetchData)
  yield takeEvery(STUDENT_SUBJECT_REPORT, fetchData)
  yield takeEvery(LOCK_SELECTED_OUTLINE, fetchData)
  yield takeEvery(UNLOCK_SELECTED_OUTLINE, fetchData)
  yield takeEvery(GET_PREVIOUS_SUBJECTS, fetchData)
  yield takeEvery(GET_SUBJECT_EXAMS, fetchData)
  yield takeEvery(ASSIGN_SUBJECT_TEACHERS, fetchData)
  yield takeEvery(GET_SUBSECTIONS, fetchData)
  yield takeEvery(CREATE_SUBSECTIONS, fetchData)
  yield takeEvery(UPDATE_SUBSECTION, fetchData)
  yield takeEvery(GET_SUBSECTION, fetchData)
  yield takeEvery(DELETE_MANY_SUBSECTION, fetchData)
  yield takeEvery(DELETE_SUBSECTION, fetchData)
  yield takeEvery(GET_EXCLUDE_SUBSECTIONS, fetchData)
  yield takeEvery(UPDATE_EXCLUDE_SUBSECTION, fetchData)
  yield takeEvery(COPY_SUBSECTION, fetchData)
  yield takeEvery(GET_SYLLABUS_SUBJECTS, fetchData)
  yield takeEvery(GET_STUDENTS_SUBJECTS_NEW, fetchData)
  yield takeEvery(GET_OBSERVEE_TEACHERS_SUBJECTS, fetchData)
  yield takeEvery(LOAD_SUBJECT_LABELS, fetchData)
  yield takeEvery(ADD_SUBJECT_RESOURCES, fetchData)
  yield takeEvery(GET_SUBJECT_RESOURCES, fetchData)
  yield takeEvery(DELETE_SUBJECT_RESOURCES, fetchData)
}

export default dataSaga
